import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { PortalApiService } from '../../../_services/portal-api.service';
import { UserProfile } from '../../../_models/user-profile';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FieldDataSheet } from '../../../_models/field';
import { ListsHelperService } from '../../_services/lists-helper.service';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'datasheet-calendar',
  templateUrl: './datasheet-calendar.component.html',
  styleUrls: ['./datasheet-calendar.component.css'],
  providers: [DatePipe]
})
export class DatasheetCalendarComponent implements OnInit, OnDestroy {
  @Input() userProfile: UserProfile;
  @Input() isLoadingField: boolean;
  @Input() ticketView: string;
  @Input() changeTicketView: (viewName: string) => void;
  @Input() updateQueryParams: (paramName: string, paramValue: any) => void;
  today: Date = new Date();
  isLoadingDataSheets: boolean = false;
  startDate: string;
  endDate: string;
  fieldID: number;
  receivedDataSheets: FieldDataSheet[] = [];
  receivedSorted: boolean = false;
  paginatePerPage: number = 25;
  p1: number = 1;
  // Errors
  errorGetDataSheets: boolean = false;
  errorMessage: string;
  alertMessage: string = null;

  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private apiService: PortalApiService,
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private listHelper: ListsHelperService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.fieldID = params['fieldID'];
    });

    this.setMaxDateToday();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getFieldDataSheets() {
    this.isLoadingDataSheets = true;
    const endDate = new Date();
    const formattedEndDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');

    this.apiService.getFieldDataSheets(this.fieldID, this.startDate, formattedEndDate).subscribe({
      next: (data: FieldDataSheet[]) => {
        console.log(data);
        this.isLoadingDataSheets = false;
        // check if there's an available datasheet
        if (data.length > 0) {
          this.receivedDataSheets = data;
          this.navigateToDailyView();
        } else {
          this.alertMessage = 'There is no data sheet available for this date. Please contact us ';
          this.setMaxDateToday();
        }
      },
      error: err => {
        console.log(err);
        this.alertMessage = null;
        this.isLoadingDataSheets = false;
        this.errorGetDataSheets = true;
        this.errorMessage = (err.error || 'An error occurred. Failed to retrieve field data sheets.');
      }
    });
  }

  setMaxDateToday() {
    /*setTimeout(() => {
      this.calendar.disabledDates = [
        { type: DateRangeType.After, dateRange: [new Date()] }
      ]
    }
    )*/
  }

  navigateToDailyView() {
    const formattedDate = this.startDate + "T00:00:00";
    let indexFound = this.receivedDataSheets.findIndex(datasheet => datasheet.entryDate == formattedDate);

    if (indexFound > -1) {
      let datasheetID = this.receivedDataSheets[indexFound].dataSheetID;
      let routePath: string = `app/Portal/dataentry/field/${this.fieldID}/datasheet/${datasheetID}/entrydate/${this.startDate}/run-tickets`;
      this.router.navigate([routePath]);
    }
  }

  onDateSelect(selectedDate) {
    // convert selectedDate to the right formate
    this.startDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    // use this as startDate to get field datasheets
    this.getFieldDataSheets();
  }
}
